import { TeamWithCollections } from 'entities';
import { StateSetter, createContext, useContext } from 'react';

export interface TeamProfileContext {
  team: TeamWithCollections;
  updateTeam: StateSetter<TeamWithCollections>;

  canMutateEntities: boolean;
}

export const teamProfileContext = createContext({} as TeamProfileContext);

export function useTeamProfile(): TeamProfileContext {
  const context = useContext(teamProfileContext);

  if (!context.updateTeam) throw new Error('Team Profile context misuse');

  return context;
}
